import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#b45309", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#92400e", lineHeight: 1.6 },
}));

const DEFAULT = {
  msgSemFaturas: "Você não possui faturas em aberto.",
};

const FlowBuilderScFaturasModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ ...DEFAULT, ...data.data.data });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    const label = "SC — Faturas";
    if (open === "edit") {
      onUpdate(data.id, { data: { label, data: cfg } });
    } else {
      onSave({ label, data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>Sys Clínica — Faturas</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Consulta as faturas em aberto do paciente na API do Sys Clínica.<br />
            Envia a lista com valor, vencimento, PIX e link de pagamento (quando disponíveis).
          </Typography>
        </Box>

        <TextField
          label="Mensagem quando sem faturas em aberto"
          value={cfg.msgSemFaturas}
          onChange={(e) => setCfg({ ...cfg, msgSemFaturas: e.target.value })}
          fullWidth margin="dense" variant="outlined" multiline minRows={2}
        />

        <Box style={{ marginTop: 16, padding: 12, background: "#fffbeb", borderRadius: 8, border: "1px solid #fcd34d" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#92400e", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#b45309" }}>
            🟠 <strong>temFaturas</strong> — paciente tem faturas em aberto (lista enviada)<br />
            ⚫ <strong>semFaturas</strong> — nenhuma fatura em aberto<br />
            🔴 <strong>erro</strong> — falha na API ou integração inativa
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderScFaturasModal;
